module.exports = __webpack_public_path__ + "static/cwu logo white-7981f83e6439315ba1eac8a46be8daf8.png";